(function(){
'use strict';
function enhance(root){
 const scope=root||document;
 const regions=scope.matches&&scope.matches('.okhomes-property-details .product__description,.okhomes-list-description__content')?[scope]:Array.from(scope.querySelectorAll('.okhomes-property-details .product__description,.okhomes-list-description__content'));
 regions.forEach(function(region){
  const walker=document.createTreeWalker(region,NodeFilter.SHOW_TEXT),nodes=[];
  while(walker.nextNode())nodes.push(walker.currentNode);
  nodes.forEach(function(node){
   if(!node.parentElement||node.parentElement.closest('strong,b,h1,h2,h3,h4,h5,h6,script,style,textarea'))return;
   const pattern=/(?<![\p{L}\p{N}])[\p{Lu}][\p{Lu}\p{N}ºª]*(?![\p{L}\p{N}])/gu;
   const text=node.textContent,matches=Array.from(text.matchAll(pattern));
   if(!matches.length)return;
   const fragment=document.createDocumentFragment();let offset=0;
   matches.forEach(function(match){
    fragment.append(document.createTextNode(text.slice(offset,match.index)));
    const strong=document.createElement('strong');strong.className='okhomes-description-subheading';strong.style.fontWeight='700';strong.textContent=match[0];fragment.append(strong);offset=match.index+match[0].length;
   });
   fragment.append(document.createTextNode(text.slice(offset)));node.replaceWith(fragment);
  });
 });
}
window.okhomesBoldDescription=enhance;
function start(){enhance(document);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',start);
})();